/**
 * Takes a fraction of a number and converts it into a rounded whole number
 *
 * EX: inNum = 0.50, returns 50
 *     inNum = 0.501, return 50
 *     inNum = 0.506, returns 51
 *     inNum = 0, returns 0
 *     inNum = null, returns null
 * @param inNum The number to transform into a whole percentage number
 * @returns a whole number that is the percentage of the inNum rounded to the nearest whole number
 */
export const calculateToWholePercent = (inNum: number) => {
  if (!inNum) return inNum;

  return Math.round(inNum * 100);
};

/**
 * Rounds to the closest step that the user wants to
 * EG: inNum = 7.74, step = 0.5 returns 7.5
 *     inNum = 7.74, step = 0.1 returns 7.7
 *     inNum = 7.74, step = 0.25 returns 7.75
 *     inNum = 7.44, step = 1 returns 8
 *
 *
 * @param inNum the number to round
 * @param step The closest 0.X% to round EG: 0.5, 0.1 ect
 */
export function roundToStep(inNum: number, step: number): number {
  if (inNum === 0) return 0;
  if (!inNum || !step) return null;

  const inverse = 1.0 / step;
  return Math.round(inNum * inverse) / inverse;
}
